export async function criarGoogleSlides(questoes, titulo) {
    try {
        const presentationResponse = await gapi.client.slides.presentations.create({ title: titulo });
        const presentationId = presentationResponse.result.presentationId;
        console.log("Apresentação criada:", presentationId);

        let requests = [];

        // Criação do primeiro slide com o título centralizado
        const titleSlideId = `title_slide`;
        requests.push({
            createSlide: {
                objectId: titleSlideId,
                insertionIndex: 0
            }
        });

        const titleTextBoxId = `title_text_box`;
        requests.push({
            createShape: {
                objectId: titleTextBoxId,
                shapeType: 'TEXT_BOX',
                elementProperties: {
                    pageObjectId: titleSlideId,
                    size: { width: { magnitude: 500, unit: 'PT' }, height: { magnitude: 120, unit: 'PT' } },
                    transform: { scaleX: 1, scaleY: 1, translateX: 120, translateY: 120, unit: 'PT' }
                }
            }
        });

        requests.push({
            insertText: {
                objectId: titleTextBoxId,
                text: titulo,
                insertionIndex: 0
            }
        });

        requests.push({
            updateTextStyle: {
                objectId: titleTextBoxId,
                textRange: {
                    type: 'ALL'
                },
                style: {
                    fontSize: { magnitude: 40, unit: 'PT' },  
                    bold: true                               
                },
                fields: 'fontSize,bold'
            }
        });


        requests.push({
            updateParagraphStyle: {
                objectId: titleTextBoxId,
                textRange: {
                    type: 'ALL'
                },
                style: {
                    alignment: 'CENTER'
                },
                fields: 'alignment'
            }
        });
    







        questoes.forEach((questao, index) => {
            const slideId = `slide_${index + 1}`;
            requests.push({
                createSlide: {
                    objectId: slideId,
                    insertionIndex: index + 1
                }
            });

            if (questao.imagem) {
                requests.push({
                    createImage: {
                        url: questao.imagem,
                        elementProperties: {
                            pageObjectId: slideId,
                            size: { width: { magnitude: 300, unit: 'PT' }, height: { magnitude: 200, unit: 'PT' } },
                            transform: { scaleX: 1, scaleY: 1, translateX: 610, translateY: 50, unit: 'PT' }
                        }
                    }
                });
            }

            const textBoxId = `textBox_${index + 1}`;
            requests.push({
                createShape: {
                    objectId: textBoxId,
                    shapeType: 'TEXT_BOX',
                    elementProperties: {
                        pageObjectId: slideId,
                        size: { width: { magnitude: 620, unit: 'PT' }, height: { magnitude: 300, unit: 'PT' } },
                        transform: { scaleX: 1, scaleY: 1, translateX: 50, translateY: 50, unit: 'PT' }
                    }
                }
            });

            let fullText = "";
            let textStartIndex = 0;

            if (questao.texto) {
                fullText += questao.texto + "\n\n"; // Inclui duas quebras de linha para espaço extra
                requests.push({
                    insertText: {
                        objectId: textBoxId,
                        text: questao.texto + "\n\n", // Adiciona espaço após o texto de descrição
                        insertionIndex: textStartIndex
                    }
                });

                requests.push({
                    updateTextStyle: {
                        objectId: textBoxId,
                        textRange: {
                            type: 'FIXED_RANGE',
                            startIndex: textStartIndex,
                            endIndex: textStartIndex + questao.texto.length + 2
                        },
                        style: {
                            fontSize: { magnitude: 13, unit: 'PT' }
                        },
                        fields: 'fontSize'
                    }
                });

                textStartIndex += questao.texto.length + 2; // Atualiza o índice para incluir as quebras de linha
            }

            fullText += questao.pergunta + "\n\n"; // Espaço após a pergunta antes das opções
            ['a', 'b', 'c', 'd', 'e'].forEach(letter => {
                if (questao[letter]) {
                    fullText += `${letter}) ${questao[letter]}\n`;
                }
            });

            requests.push({
                insertText: {
                    objectId: textBoxId,
                    text: questao.pergunta + "\n\n" + ['a', 'b', 'c', 'd', 'e'].map(letter => questao[letter] ? `${letter}) ${questao[letter]}\n` : "").join(''),
                    insertionIndex: textStartIndex
                }
            });
        });

        const batchUpdateResponse = await gapi.client.slides.presentations.batchUpdate({
            presentationId: presentationId,
            requests: requests
        });
        console.log("Apresentação atualizada com sucesso.", batchUpdateResponse.result);

        return { status: 'sucesso', slideId: presentationId };
    } catch (error) {
        console.error("Erro ao criar ou atualizar a apresentação:", error);

        return { status: 'erro', erro: error.result.error.message };
    }
}
